import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { News } from '../../models';

import { ImageComponent } from '@teamfoster/sdk/image';
import { StripHtmlPipe } from '@teamfoster/sdk/text-utility';
import { RouterLink } from '@angular/router';
import { NewsDatePipe } from '../../pipes/news-date.pipe';

@Component({
    selector: 'app-news-list-card',
    imports: [ImageComponent, StripHtmlPipe, RouterLink, NewsDatePipe],
    templateUrl: './news-list-card.component.html',
    styleUrl: './news-list-card.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class NewsListCardComponent {
  news = input.required<News>();
}
